import React, { useEffect, useState } from 'react';
import { FiClock, FiCheck } from 'react-icons/fi';
import TIA from '@/components/custom/tia';
import { useNavigate } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import { GuideCard, GuideCardCheck, GuideCardContent, GuideCardIcon, GuideCardTime, GuideCardTitle } from '@/components/custom/guide';
import { BadgeTruncate } from '@/components/ui/badge';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { PlayfulCard } from '@/components/custom/playful-card';
import { cn } from '@/lib/utils';

export function StudyGuideCard(props) {
  const navigate = useNavigate();
  const playful = usePlayfulStudent();
  const { done, title, isCurrent, video, guide_index, canBeClicked = false } = props;

  const client = useClient();
  const [tiaMessageProgressMarch, setTiaMessageProgressMarch] = useState(null);

  const getTiaMessageBlock = async id => {
    const response = await client.mutate(`study_plan_videos/${id}/tia_message_blocks`, {}, { method: 'post' });
    return response.data;
  };

  useEffect(() => {
    if (isCurrent) {
      getTiaMessageBlock(video.id).then(data => {
        setTiaMessageProgressMarch(data?.body);
      });
    }
  }, []);

  const clockIconsCount = guide_index % 2 === 0 ? 3 : 2;
  const clockIcons = Array.from({ length: clockIconsCount }, (_, index) => (
    <GuideCardIcon>
      <FiClock key={index} />
    </GuideCardIcon>
  ));

  if (playful) {
    return (
      <PlayfulCard
        onClick={() => {
          if (canBeClicked) navigate(`/guia-de-estudos/bloco-de-estudo/${video.id}`);
        }}
        className={cn('cursor-pointer p-4', !canBeClicked && 'cursor-not-allowed opacity-70', isCurrent && 'ring-2 ring-[var(--color-mission)]')}
        style={{ background: '#fff' }}
      >
        <div className="flex items-start gap-3">
          <div
            className={cn('mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2', done ? 'border-[#D3FCD2] bg-[#D3FCD2]' : 'border-neutral-200')}
            role="img"
            aria-label={done ? 'Concluído' : 'Não concluído'}
          >
            {done && <FiCheck className="h-3.5 w-3.5" />}
          </div>

          <div className="min-w-0 flex-1">
            <p
              className="mb-1 text-sm font-extrabold"
              style={{ color: '#222731' }}
            >
              {title}
            </p>
            <BadgeTruncate items={video.video?.taxonomies} />
          </div>

          <div className="flex shrink-0 flex-col items-end gap-1.5">
            {done && <span className="rounded-[4px] bg-[#D3FCD2] px-1.5 py-0.5 text-[10px] font-extrabold uppercase leading-none tracking-wide text-[#0A5C36]">Concluído</span>}
            <div className="flex items-center gap-0.5 text-[var(--color-mission)]">{clockIcons}</div>
          </div>
        </div>

        {isCurrent && tiaMessageProgressMarch && (
          <div className="mt-3">
            <TIA message={tiaMessageProgressMarch} />
          </div>
        )}
      </PlayfulCard>
    );
  }

  return (
    <GuideCard
      isCurrent={isCurrent}
      onClick={() => {
        if (canBeClicked) navigate(`/guia-de-estudos/bloco-de-estudo/${video.id}`);
      }}
      style={{ cursor: canBeClicked ? 'pointer' : 'not-allowed' }}
    >
      <GuideCardCheck
        name="done"
        checked={done}
        readOnly
      />

      <GuideCardContent>
        <GuideCardTitle>{title}</GuideCardTitle>

        <BadgeTruncate
          items={video.video?.taxonomies}
          oneLine
        />
      </GuideCardContent>

      <GuideCardTime>{clockIcons}</GuideCardTime>

      {isCurrent && tiaMessageProgressMarch && <TIA message={tiaMessageProgressMarch} />}
    </GuideCard>
  );
}
